<template>
  <v-container fill-height fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%;width:100%">
      <AdminSideBarMenu />
      <v-flex class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Admin</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Resources</v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-card class="bordered-card" style="height: 100%;">
          <v-toolbar class="grey lighten-4 elevation-0">
            <v-toolbar-title class="grey--text text-underline text--darken-4">
              Resources
            </v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-flex xs4>
              <v-btn @click.prevent="goto('/admin/resources/new')">
                <v-icon>add</v-icon>
                Add new
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-data-table :headers="headers" :items="resources" :rows-per-page-items="[15, 25, 50, 100]">
            <template slot="items" slot-scope="props">
              <tr class="content-table-row">
                <td>{{ props.item.submitdate | actualDate }}</td>
                <td>{{ props.item.revisiondate | actualDate }}</td>
                <td class="no-wrap-cell">
                  {{ props.item.user.firstname }} {{ props.item.user.lastname }}
                </td>
                <td>{{ props.item.title }}</td>
                <td class="no-wrap-cell">{{ props.item.category }}</td>
                <td class="no-wrap-cell">{{ props.item.featured === true ? 'Featured' : 'Not Featured' }}</td>
                <td class="no-wrap-cell">
                  <v-tooltip top v-if="props.item.featured === false">
                    <v-btn slot="activator" @click.prevent="approveSubmission(props.item.id, props.item.submitby)" icon class="green--text">
                      <v-icon>done</v-icon>
                    </v-btn>
                    <span>Feature</span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <v-btn slot="activator" @click.prevent="rejectSubmission(props.item.id, props.item.submitby)" icon class="red--text">
                      <v-icon>clear</v-icon>
                    </v-btn>
                    <span>Remove Featured</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn @click.prevent="goto('/admin/resources/new?mode=edit&id=' + props.item.id)" slot="activator" icon class="blue--text">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-btn icon medium @click="assignId(props.item.id, 'emailDialog')">
                    <v-icon medium>email</v-icon>
                  </v-btn>
                  <v-btn icon @click="openViewModal(props.item)" class="blue--text">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn slot="activator" icon @click.prevent="assignId(props.item.id, 'dialog')" class="red--text">
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>
        <PageFooter />
      </v-flex>
      <v-dialog v-model="emailDialog" lazy absolute max-width="500px">
        <v-card>
          <v-card-title>
            <div class="headline">Confim Email</div>
          </v-card-title>
          <v-card-text>Are you sure you want to notify all users?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog = false">No</v-btn>
            <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog= false;sendMail()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" lazy absolute max-width="500px">
        <v-card>
          <v-card-title>
            <div class="headline">Really delete?</div>
          </v-card-title>
          <v-card-text>Are you sure you want to delete?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
            <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteRow()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <resources-modal :dialog="view_dialog" :item="selectedItem" @cancel="cancelViewModal()" style="width:600px;" />
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import ResourcesModal from "@/components/modal/info/resourceViewModal.vue";
import AdminSideBarMenu from './Components/AdminSideBar.vue'
import PageFooter from './Components/PageFooter.vue'

export default {
  components: {
    AdminSideBarMenu,
    PageFooter,
    ResourcesModal
  },
  mounted () {
    this.$store.dispatch('fetchResources')
    const payload = {
      meta: {
        h1: "Admin Resources",
        title: "Resources",
        description: "Admin Settings",
        keywords: "",
        requiresAuth: true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit("setHeaderInfo", payload);
  },
  computed: {
    resources () {
	    return this.$store.getters.getResources
    },
    process () {
      return this.$store.getters.getProcess
    },
    allResources () {
        return this.resources.filter((company) => company.verified === this.currentStatus).sort((d1, d2) => new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime())
    }
  },
  data () {
    return {
      search: '',
      e1: '',
      ex11: true,
      pagination: {},
      selectedItem: null,
      cmp1: [],
      pickedItem: {},
      dialog: false,
      currentStatus: 'all',
      currentEventId: '',
      dateRange: 0,
      view_dialog: false,
      emailDialog: false,
      info: [
        {
          name: 'Company Info',
          tabId: 'company_info'
        },
        {
          name: 'Contracting Info',
          tabId: 'contracting_info'
        },
        {
          name: 'Other Info',
          tabId: 'other_info'
        }
      ],
      headers: [
        {
          text: 'Submit date',
          align: 'left',
          sortable: false,
          value: 'submitdate'
        },
        {
          text: 'Revision Date',
          align: 'left',
          sortable: false,
          value: 'revisiondate'
        },
        {
          text: 'Submitted by',
          value: 'user',
          align: 'left',
          sortable: false
        },
        {
          text: 'Title',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Category',
          align: 'left',
          sortable: false,
          value: 'category'
        },
        {
          text: 'Status',
          value: 'verified',
          align: 'left',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'left',
          sortable: false
        }
      ],
      items: [],
      currentResourceId: null
    }
  },
  methods: {
    cancelViewModal() {
      this.view_dialog = false;
    },
    openViewModal (item) {
      this.view_dialog = true
      this.selectedItem = item
    },
    approveSubmission (id, uid) {
      this.$store.dispatch('toggleResourceSubmission', {id: id, uid: uid, value: true})
    },
    rejectSubmission (id, uid) {
      this.$store.dispatch('toggleResourceSubmission', {id: id, uid: uid, value: false})
    },
    filterStatus (status) {
      this.currentStatus = status
    },
    deleteRow () {
      const payload = {
        type: 'resources',
        postId: this.currentResourceId
      }
      this.$store.dispatch('deletePost', payload)
      this.dialog = false
    },
    sendMail () {
      this.$store.dispatch('sendEmailToAllUsers', { type: 'new_resource' })
    },
    assignId (postId, type) {
      this.currentResourceId = postId
      this.pickedItem = this.resources.find(item => item.id === postId)
      this[type] = true
    },
    goto(link) {
      this.$router.push(link)
    }
  }
}
</script>
<style>
  #right {
    float: right !important;
  }
  #toggle_status {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// ResourcesListView.vue?b60e5d6c